import PropTypes from "prop-types";

const MenuIcon = ({ color = "#ffffff", width = 54, height = 36 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 54 36"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill={color}>
        <rect x="0" y="0" width="54" height="4" />
        <rect x="0" y="16" width="54" height="4" />
        <rect x="0" y="32" width="54" height="4" />
      </g>
    </g>
  </svg>
);

MenuIcon.propTypes = {
  color: PropTypes.string, // Icon color
  width: PropTypes.number, // SVG width
  height: PropTypes.number, // SVG height
};

export default MenuIcon;
